import React from "react";

function DashboardUI() {
  return <div>DashboardUI</div>;
}

export default DashboardUI;
